export default {
    "created": "Oferta a fost creata cu succes",
    "updated": "Oferta a fost actualizata cu succes",
    "deleted": "Oferta a fost ștearsa cu succes",
    "restored": "Oferta a fost restaurata cu succes",
}
